import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { loadingFade } from '../../animacoes';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';

import { UsuarioService } from '../services/usuario.service';
import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { ProfissionalService } from '../services/profissional.service';
import { VeiculoService } from '../services/veiculo.service';
import { CheckMotoService } from '../services/check-moto.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-checklist-moto-edit',
  templateUrl: './checklist-moto-edit.component.html',
  styleUrls: ['./checklist-moto-edit.component.css'],
	animations: [loadingFade]
})
export class ChecklistMotoEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public inicioPeriodo;

	public formChecklist: FormGroup;

  public agencias = [];
  public unidades = [];
  public profissionais = [];
  public veiculos = [];

  public profissional = null;
  public check_moto_id = null;

    //filtros
    public cliente_id___cliente = null;
    public unidade_id___unidade = null;
    public veiculo_id___veiculo = null;
    public check_moto_turno___periodo = null;
    public check_moto_data___data_i = null;
    public check_moto_data___data_f=  null;
    public especialidade_veiculo_id___veiculo = null;
    public profissional_id___profissional = null;

  // datepickers
	private data_checklist_dp;
  private data_oleo_checklist_dp;
  
  constructor(private authSvc: AuthService,
              private usuarioSvc: UsuarioService,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              private router: Router,
              private clienteSvc: ClienteService,
              private unidadeSvc: UnidadeService,
              private profissionalSvc: ProfissionalService ,
              private veiculoSvc: VeiculoService,
              private checkMotoSvc: CheckMotoService,
              ) { }

  ngOnInit() {
    this.pegaAgencias();
    //this.pegaProfissionais()
    this.criaForm();
    this.verificaCliente();
    this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {


        var splitFiltro = params.id.split("?");

        if(splitFiltro[1] !== undefined){
          
          var splitfiltro = splitFiltro[1].split("&");
          for (let f in splitfiltro) {

            var loSplitValor = splitfiltro[f].split("=");

            switch(loSplitValor[0]) { 
              case "cliente_id___cliente": { 
                 this.cliente_id___cliente = loSplitValor[1];
                 break; 
              } 
              case "unidade_id___unidade": { 
                this.unidade_id___unidade = loSplitValor[1];
                 break; 
              } 
              case "veiculo_id___veiculo": { 
                this.veiculo_id___veiculo = loSplitValor[1];
                 break; 
              } 
              case "check_moto_turno___periodo": { 
                this.check_moto_turno___periodo = loSplitValor[1];
                 break; 
              }     
              case "check_moto_data___data_i": { 
                this.check_moto_data___data_i = loSplitValor[1];
                 break; 
              }      
              case "check_moto_data___data_f": { 
                this.check_moto_data___data_f = loSplitValor[1];
                 break; 
              }      
              case "especialidade_veiculo_id___veiculo": { 
                this.especialidade_veiculo_id___veiculo = loSplitValor[1];
                 break; 
              }    
              case "profissional_id___profissional": { 
                this.profissional_id___profissional = loSplitValor[1];
                 break; 
              }                                                            
           }

          }


        }        


        this.check_moto_id = params.id;
				this.checkMotoSvc.getCheckMoto(params.id).then((data: any) => {
          this.pegaUnidadesByAgencia(data.cliente_id);
          this.pegaVeiculosByUnidade(data.unidade_id);
          this.onChangeVeiculoUnidade(data);
					this.preencheForm({
            check_moto_id: data.check_moto_id,
            usuario_id: data.usuario_id,
            unidade_id: data.unidade_id, 
            cliente_id: data.cliente_id, 
            check_moto_data: moment(data.check_moto_data, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            check_moto_turno: data.check_moto_turno,
            check_moto_justificativa: data.check_moto_justificativa,
            profissional_id: data.profissional_id,
            veiculo_id: data.veiculo_id,
            check_moto_quilometragem: this.mascaraKm(data.check_moto_quilometragem),
            check_moto_combustivel: data.check_moto_combustivel,
            check_moto_oleo_motor: data.check_moto_oleo_motor,
            check_moto_oleo_motor_obs: data.check_moto_oleo_motor_obs,
            check_moto_corrente: data.check_moto_corrente,
            check_moto_corrente_obs: data.check_moto_corrente_obs,
            check_moto_freio: data.check_moto_freio,
            check_moto_freio_obs: data.check_moto_freio_obs,
            check_moto_pneus: data.check_moto_pneus,
            check_moto_pneus_obs: data.check_moto_pneus_obs,
            check_moto_retrovisor_dir: data.check_moto_retrovisor_dir,
            check_moto_retrovisor_dir_obs: data.check_moto_retrovisor_dir_obs,
            check_moto_retrovisor_esq  : data.check_moto_retrovisor_esq,
            check_moto_retrovisor_esq_obs: data.check_moto_retrovisor_esq_obs,
            check_moto_meia_luz: data.check_moto_meia_luz,
            check_moto_meia_luz_obs: data.check_moto_meia_luz_obs,
            check_moto_luz_baixa: data.check_moto_luz_baixa,
            check_moto_luz_baixa_obs: data.check_moto_luz_baixa_obs,
            check_moto_luz_alta: data.check_moto_luz_alta,
            check_moto_luz_alta_obs: data.check_moto_luz_alta_obs,
            check_moto_pisca_direito: data.check_moto_pisca_direito,
            check_moto_pisca_direito_obs: data.check_moto_pisca_direito_obs,
            check_moto_pisca_esquerdo: data.check_moto_pisca_esquerdo, 
            check_moto_pisca_esquerdo_obs: data.check_moto_pisca_esquerdo_obs, 
            check_moto_partida: data.check_moto_partida,
            check_moto_partida_obs: data.check_moto_partida_obs,
            check_moto_luz_freio: data.check_moto_luz_freio,
            check_moto_luz_freio_obs: data.check_moto_luz_freio_obs,
            check_moto_lanterna_tra: data.check_moto_lanterna_tra,
            check_moto_lanterna_tra_obs: data.check_moto_lanterna_tra_obs,
            check_moto_sirene: data.check_moto_sirene,
            check_moto_sirene_obs: data.check_moto_sirene_obs,
            check_moto_buzina: data.check_moto_buzina,
            check_moto_buzina_obs: data.check_moto_buzina_obs,
            check_moto_giroflex: data.check_moto_giroflex,
            check_moto_giroflex_obs: data.check_moto_giroflex_obs,
            check_moto_estrobo: data.check_moto_estrobo,
            check_moto_estrobo_obs: data.check_moto_estrobo_obs,
            check_moto_capacete: data.check_moto_capacete,
            check_moto_capacete_obs: data.check_moto_capacete_obs,
            check_moto_joelheira: data.check_moto_joelheira,
            check_moto_joelheira_obs: data.check_moto_joelheira_obs,
            check_moto_cotoveleira: data.check_moto_cotoveleira,
            check_moto_cotoveleira_obs: data.check_moto_cotoveleira_obs,
            check_moto_luvas: data.check_moto_luvas,
            check_moto_luvas_obs: data.check_moto_luvas_obs,
            check_moto_botas: data.check_moto_botas,
            check_moto_botas_obs: data.check_moto_botas_obs,
            check_moto_colete: data.check_moto_colete,
            check_moto_colete_obs: data.check_moto_colete_obs,
            check_moto_jaqueta: data.check_moto_jaqueta,
            check_moto_jaqueta_obs: data.check_moto_jaqueta_obs,
            check_moto_capa: data.check_moto_capa,
            check_moto_capa_obs: data.check_moto_capa_obs,
            check_moto_documento: data.check_moto_documento,
            check_moto_documento_obs: data.check_moto_documento_obs,
            check_moto_cartao_abastecimento: data.check_moto_cartao_abastecimento,
            check_moto_cartao_abastecimento_obs: data.check_moto_cartao_abastecimento_obs,
            check_moto_gps: data.check_moto_gps,
            check_moto_gps_obs: data.check_moto_gps_obs,
            check_moto_celular: data.check_moto_celular, 
            check_moto_celular_obs: data.check_moto_celular_obs,
            check_moto_registro: data.check_moto_registro,
            check_moto_inicio:data.check_moto_inicio,
            check_moto_fim:data.check_moto_fim,
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
  }

  criaForm(){
    this.formChecklist = this.fb.group({
			check_moto_id: null,
      usuario_id: this.authSvc.getUsuarioId(),
      unidade_id: [null, Validators.required],
      cliente_id: [null, Validators.required],
      check_moto_data: [moment().format('DD/MM/YYYY'), Validators.required],
      check_moto_turno: [this.pegaPeriodo(), Validators.required],
      check_moto_justificativa: null,
      profissional_id: [null, Validators.required],
      veiculo_id: [null, Validators.required],
      check_moto_quilometragem: [null, Validators.required],
      check_moto_combustivel: [null, Validators.required],
      check_moto_oleo_motor: [null, Validators.required],
      check_moto_oleo_motor_obs: null,
      check_moto_corrente: [null, Validators.required],
      check_moto_corrente_obs: null,
      check_moto_freio: [null, Validators.required],
      check_moto_freio_obs: null,
      check_moto_pneus: [null, Validators.required],
      check_moto_pneus_obs: null,
      check_moto_retrovisor_dir: [null, Validators.required],
      check_moto_retrovisor_dir_obs: null,
      check_moto_retrovisor_esq  : [null, Validators.required],
      check_moto_retrovisor_esq_obs: null,
      check_moto_meia_luz: [null, Validators.required],
      check_moto_meia_luz_obs: null,
      check_moto_luz_baixa: [null, Validators.required],
      check_moto_luz_baixa_obs: null,
      check_moto_luz_alta: [null, Validators.required],
      check_moto_luz_alta_obs: null,
      check_moto_pisca_direito: [null, Validators.required],
      check_moto_pisca_direito_obs: null,
      check_moto_pisca_esquerdo: [null, Validators.required],
      check_moto_pisca_esquerdo_obs: null,
      check_moto_partida: [null, Validators.required],
      check_moto_partida_obs: null,
      check_moto_luz_freio: [null, Validators.required],
      check_moto_luz_freio_obs    : null,
      check_moto_lanterna_tra  : [null, Validators.required],
      check_moto_lanterna_tra_obs: null,
      check_moto_sirene: [null, Validators.required],
      check_moto_sirene_obs: null,
      check_moto_buzina: [null, Validators.required],
      check_moto_buzina_obs: null,
      check_moto_giroflex: [null, Validators.required],
      check_moto_giroflex_obs: null,
      check_moto_estrobo: [null, Validators.required],
      check_moto_estrobo_obs  : null,
      check_moto_capacete: [null, Validators.required],
      check_moto_capacete_obs: null,
      check_moto_joelheira: [null, Validators.required],
      check_moto_joelheira_obs: null,
      check_moto_cotoveleira: [null, Validators.required],
      check_moto_cotoveleira_obs: null,
      check_moto_luvas: [null, Validators.required],
      check_moto_luvas_obs: null,
      check_moto_botas: [null, Validators.required],
      check_moto_botas_obs: null,
      check_moto_colete: [null, Validators.required],
      check_moto_colete_obs   : null,
      check_moto_jaqueta: [null, Validators.required],
      check_moto_jaqueta_obs: null,
      check_moto_capa: [null, Validators.required],
      check_moto_capa_obs: null,
      check_moto_documento: [null, Validators.required],
      check_moto_documento_obs: null,
      check_moto_cartao_abastecimento: [null, Validators.required],
      check_moto_cartao_abastecimento_obs: null,
      check_moto_gps: [null, Validators.required],
      check_moto_gps_obs: null,
      check_moto_celular: [null, Validators.required],
      check_moto_celular_obs: null,
      check_moto_registro:null,
      check_moto_inicio: moment().format('YYYY-MM-DD HH:mm:ss'),
      check_moto_fim: null
    });
    
    moment.locale('pt-Br');
    this.data_checklist_dp = Datepicker('#check_moto_data', {
			customMonths: moment.months(),
			customDays: moment.weekdaysShort(),
			overlayPlaceholder: 'Preencha o ano',
			overlayButton: 'Enviar',
			formatter: (element, date) => {
				let formatted = moment(date).format('DD/MM/YYYY');
				this.formChecklist.controls['check_moto_data'].setValue(formatted);
			}
    });
    let hora = parseInt(moment().format('HH'));
    let min = parseInt(moment().format('mm'));
    if([7, 19].includes(hora) && (min >= 0 && min < 31)){
      this.inicioPeriodo = true;
    }else{      
      this.inicioPeriodo = false;
    }

    if(this.authSvc.getPerfil() != 2){
      this.usuarioSvc.getUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
        this.profissional = data.profissional_id;
        this.formChecklist.get('profissional_id').setValue(data.profissional_id);
        this.formChecklist.get('profissional_id').updateValueAndValidity();
        this.formChecklist.get('profissional_id').disable();
      });
    }
  }

  preencheForm(dados) {
		this.formChecklist.setValue(dados);
  }
  
  pegaPeriodo(){
    let hora = parseInt(moment().format('HH'));
    if(hora > 7  &&  hora < 19){
      return 'D';
    }
    else{
      return 'N';
    }
  }

  pegaAgencias(){
    this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.agencias = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaUnidadesByAgencia(agencia_id){
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), agencia_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }
  
  pegaVeiculosByUnidade(unidade_id){
    this.veiculoSvc.getByTipoVeiculo(unidade_id, 2).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  onChangeAgencia(e){
    this.formChecklist.controls.unidade_id.setValue(null);
    this.formChecklist.controls.veiculo_id.setValue(null);
    this.verificaCliente();
    this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), e.cliente_id).then((data: any) => {
      this.unidades = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeUnidade(e){
    this.veiculoSvc.getByTipoVeiculo(e.unidade_id, 2).then((data: any[]) => {
      this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
  }

  onChangeVeiculoUnidade(e){

		this.loading = true;
			this.veiculos = []
			this.veiculoSvc.getByVeiculoUnidadeEspecialidade(e.unidade_id,"moto").then((data: any[]) => {
	
			let dados = [];
			for(let veiculo of data){
			  dados.push({
				veiculo_id: veiculo.veiculo_id,
				placa_numero: veiculo.veiculo_placa + ' - ' + veiculo.veiculo_numero,
				unidade_id: e.unidade_id,
				cliente_id: e.cliente_id
			  });
			}
	
			this.veiculos = dados;
			this.pegaProfissionaisClienteUnidade(e)
	
			this.loading = false;
		  }).catch((err) => {
			console.log(err);
		  });
	}
	
	pegaProfissionaisClienteUnidade(e){
		this.loading = true;
		
		this.profissionalSvc.getProfissionalEdit(e.cliente_id,e.unidade_id).then((data: any[]) => {
				this.profissionais = data;
	
		  this.loading = false;
			}).catch((err) => {
				console.log(err);
			});
	  }	

  pegaProfissionais(){
    this.profissionalSvc.getProfissionais().then((data: any[]) => {
			this.profissionais = data;
		}).catch((err) => {
			console.log(err);
		});
  }
  
  invalid(nome) {
		let input = this.formChecklist.get(nome);
		return input.touched && input.invalid;
  }
  
  verificaCliente() {
		if (this.formChecklist.get('cliente_id').value)
			this.formChecklist.get('unidade_id').enable();
		else
			this.formChecklist.get('unidade_id').disable();
  }
  
  enviaChecklist() {

    if (this.formChecklist.valid) {
      this.submitting = true;
      this.formChecklist.get('profissional_id').enable();
			let toSend = this.formChecklist.value;
      if (this.check_moto_id === null) { // criar
        toSend.check_moto_registro = moment().format('YYYY-MM-DD HH:mm:ss');
        toSend.check_moto_fim = moment().format('YYYY-MM-DD HH:mm:ss');
        
        console.log("Criar");
        console.log(toSend);
				this.checkMotoSvc.criaCheckMoto(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Checklist cadastrado com sucesso!',
            onClose: ()=>{
          		this.router.navigate(['home/checkmoto']);
            }
          });
				}).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
				});
			}
			else { // editar
        console.log("Edita",toSend);
				this.checkMotoSvc.editaCheckMoto(toSend).then((data) => {
          console.log('resp', data);
				  Swal.fire({
            type: 'success',
            title: 'Checklist alterado com sucesso!',
            onClose: ()=>{
          		this.router.navigate(['home/checkmoto']);
            }
          });
				}).catch(err => {
					console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde!'
          });
				});
			}
    }
    else{
      Swal.fire({
        type: 'error',
        title: 'Checklist incompleto!',
        text: 'Verifique os itens em vermelho!'
      });
      for( let field in this.formChecklist.controls){
        let campo = this.formChecklist.get(field);
        campo.markAsTouched();
      }
    }
  }

  onChangeRadio(nome) {

    let inputRadio = this.formChecklist.get(nome);
    let inputObs = this.formChecklist.get(nome + '_obs');

    if (inputRadio.value === 'N') {
      inputObs.setValidators(Validators.required);
      inputObs.updateValueAndValidity();
      inputObs.markAsTouched();
      inputObs.invalid;
    } else {
      inputObs.clearValidators();
      inputObs.updateValueAndValidity();
    }
  }

  onClickVoltar(){

    let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
    params += "&unidade_id___unidade=" + this.unidade_id___unidade;
    params += "&veiculo_id___veiculo=" + this.veiculo_id___veiculo;
    params += "&check_moto_turno___periodo=" + this.check_moto_turno___periodo;
    params += "&check_moto_data___data_i=" + this.check_moto_data___data_i;
    params += "&check_moto_data___data_f=" + this.check_moto_data___data_f;
    params += "&especialidade_veiculo_id___veiculo=" + this.especialidade_veiculo_id___veiculo;
    params += "&profissional_id___profissional=" + this.profissional_id___profissional;

    //this.router.navigate(['/home/checkmotofiltro/' + params]);
    this.router.navigate(['/home/checkmoto']);

  }

  mascaraKm(valor){

		if(valor != "" && valor != null){

			if(valor.length <= 3){
				return valor;
			}else{

				if(valor.indexOf(".") != -1){

					var sValor = valor.split(".");
					if(sValor[1] == "000"){
						return sValor[0];
					}else{
						return sValor[0] + sValor[1];
					}

				}

			}


		}else{
      return "";
    }

	  }
  
}
